// extracted by mini-css-extract-plugin
module.exports =  {"pageHeader":"pageHeader__HJqUA","navbar":"navbar__WWQYS","navbarColor":"navbarColor__37071","navbarWrapper":"navbarWrapper__JPZSy"};